import * as React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import {
  UniversityEntity,
} from 'vse-material-ui';

export interface ResetPasswordGridProps {
  universityOptions: UniversityEntity[],
  onSubmit: (homeUniversityID: string | number, password: string, confirmPassword: string) => void,
}
export function ResetPasswordGrid(props: ResetPasswordGridProps) {
  const [homeUniversityID, setHomeUniversityID] = React.useState<string | number>('');
  const [password, setPassword] = React.useState<string>('');
  const [confirmPassword, setConfirmPassword] = React.useState<string>('');

  return (
    <Grid container>
      <Grid item xs={12} component={Typography} variant='h6'>Reset Password</Grid>
      <Grid item xs={12} component={Typography} variant='body2'>Please enter the following information to reset your APRU VSE application account password</Grid>
      <Grid item xs={12}>
        <TextField
          label='Home University'
          select
          required
          value={homeUniversityID}
          onChange={
            (ev) => setHomeUniversityID(ev.target.value)
          }
        >
          {props.universityOptions.map((option) => (
            <MenuItem key={option.universityID} value={option.universityID}>
              {option.universityName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField required type='password' label='Password' value={password} onChange={
          (ev) => setPassword(ev.target.value)
        } />
      </Grid>
      <Grid item xs={12}>
        <TextField required type='password' label='Confirm Password' value={confirmPassword} onChange={
          (ev) => setConfirmPassword(ev.target.value)
        } />
      </Grid>
      <Grid item xs={12} md={12}>
        <Typography variant="subtitle2">Note</Typography>
        <Typography variant="body2">Your password must be at least 8 characters and contain at least:</Typography>
        <ul>
          <li>one uppercase letter;</li>
          <li>one lowercase letter;</li>
          <li>one numeric; and</li>
          <li>one non-alphanumeric character</li>
        </ul>
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={
            () => props.onSubmit(homeUniversityID, password, confirmPassword)
          }
        >Submit</Button>
      </Grid>
    </Grid>
  );
}
